<template>
  <div
    class="bbp-popup-buttons"
    :style="popupPosition"
    @mouseleave="closeControls"
  >
    <div
      class="bbp-popup-buttons__item"
      @click.stop="onButtonTop"
    >
      {{buttonNameTop}}
    </div>
    <div
      class="bbp-popup-buttons__item"
      @click.stop="onButtonBottom"
    >
      {{buttonNameBottom}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPPopupButtons',
  props: {
    popupPosition: {
      type: Object,
      default: () => ({})
    },
    buttonNameTop: {
      type: String,
      default: 'Edit'
    },
    buttonNameBottom: {
      type: String,
      default: 'Delete'
    }
  },
  methods: {
    closeControls () {
      this.$emit('update:isShowPopupButton', false)
    },
    onButtonTop () {
      this.$emit('onButtonTop')
    },
    onButtonBottom () {
      this.$emit('onButtonBottom')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-popup-buttons {
    position: absolute;
    bottom: -73px;
    left: auto;
    min-height: 68px;
    max-height: 68px;
    min-width: 92px;
    max-width: 92px;
    background: $color-white;
    box-shadow: 0 0 15px rgba($color-black, 0.12);
    border-radius: 4px;
    z-index: 5;

    &__item {
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      color: $color-black;
      padding: 10px;
      transition: 0.3s;

      &:hover {
        color: $color-accent;
      }

      &:last-child {
        box-sizing: border-box;
        border-top: 1px solid $color-wild-sand;
      }
    }

    &:before {
      content: '';
      position: absolute;
      left: 40px;
      top: -6px;
      display: block;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid $color-white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPPopups/BBPPopupButtons.vue